import React from "react";
import { connect } from "react-redux";
import LocationsTable from "./LocationsTable";
import LocationsForm from "./LocationsForm";
import { mapStateToProps, mapDispatchToProps } from "./Locations.state";
import { Navigation } from "../..";
import { Pages } from "../../types";
import { Box, ButtonWithLink, Cluster, Title } from "@thecb/components";

const LocationsControls = () => {
  return (
    <Box padding="0 0 0.5rem">
      <ButtonWithLink
        variant="primary"
        url={`/pos-config/locations/create`}
        text="Create New Location"
        extraStyles={`
          border-radius: 19px;
          margin: 0;
        `}
      />
    </Box>
  );
};

const LocationsPage = () => {
  return (
    <>
      <Title as="h1" weight="bold">
        Locations
      </Title>
      <Cluster align="center" justify="space-between">
        <Navigation page={Pages.LOCATIONS} />
        <LocationsControls />
      </Cluster>
      <LocationsTable />
    </>
  );
};

const ConnectedLocationsForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationsForm);

export { LocationsPage, ConnectedLocationsForm as LocationsForm };
